module['exports'] = ['گائے', 'نیلی گاٗیے', 'امریکی گاٗیے'];
